export default __webpack_public_path__ + "static/media/swing_2.c1cf950a.svg";